// src/serviceWorkerRegistration.js

// This function can be called on every page load to register the service worker
// for caching and offline functionality.
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      navigator.serviceWorker.register(swUrl)
        .then(registration => {
          console.log('Service Worker registered successfully:', registration.scope);
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
}

// Helper function to convert VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Sends the subscription object and role to your server's /api/subscribe endpoint
async function sendSubscriptionToServer(subscription, role) {
  try {
    // IMPORTANT: Using a relative URL. The proxy in package.json handles this in development.
    const response = await fetch('/api/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // IMPORTANT: Sending the subscription object AND the role
      body: JSON.stringify({ subscription, role }),
    });

    if (!response.ok) {
      throw new Error('Failed to send subscription to server.');
    }
    console.log('Subscription sent to server successfully.');
  } catch (error) {
    console.error('Error sending subscription to server:', error);
  }
}

// This is the main function to call when a user (especially an admin) logs in.
export async function registerForPushNotifications(role) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push messaging is not supported');
    return;
  }

  try {
    // Get the service worker registration
    const registration = await navigator.serviceWorker.ready;

    // Check if a subscription already exists
    let subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      console.log('User is already subscribed.');
      // Optionally, re-send to the server to ensure it's up to date
      await sendSubscriptionToServer(subscription, role);
      return;
    }

    // Request permission from the user
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Push notification permission was not granted.');
      return;
    }

    // Subscribe the user
    const vapidPublicKey = 'BBgo5x0k4M_Qg-fqEUn0A7gf9Ra0Tpa-t5HFMS-3N6A1zPxlLuD1rvA6j20IWykGGgRF-Oamf7MgWpSKkqIHyOI';
    const newSubscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    });

    console.log('New push subscription created:', newSubscription);

    // Send the new subscription to your server
    await sendSubscriptionToServer(newSubscription, role);
  } catch (error) {
    console.error('Failed to subscribe the user for push notifications:', error);
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}

